import SelectInputServerError from '@perpay-web/components/higher-order/WithFieldServerErrors/SelectInputServerError';
import { withFormikInputWrapper } from '@perpay-web/components/higher-order/WithFormikInputWrapper/WithFormikInputWrapper';

const FormikSelectInput = withFormikInputWrapper(SelectInputServerError);

/**
 * @type {any}
 */
export default FormikSelectInput;
